// export const CONTINGENCY = 5 / 100; // 5%
export const CONTINGENCY = 5 / 100;
export const CONTINGENCY_PERCENTAGE_TEXT = `${CONTINGENCY * 100}`;
